<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { ButtonV2, CircleAvatar, Text } from '@Shelly/shelly-design-system/index';

	/** Blocked-state placeholder for an image preview: icon, message and an optional cta.
	 *
	 * The video path has `VideoContainer` for the same job, but that one also owns
	 * playback concerns (zoom, loader, slot gating), so an image that cannot be
	 * shown — encrypted without a key, for instance — states its case here instead. */

	export let icon = 'fal fa-image-slash';
	export let heading = '';
	export let message = '';
	/** Omit to show the state without an action. */
	export let ctaTitle = '';
	/** Matches the layout the placeholder fills (a list preview needs a smaller icon). */
	export let avatarSize: 's' | 'm' | 'm_plus' | 'l' | 'xl' | 'xxl' = 'l';

	const dispatch = createEventDispatcher<{ cta: void }>();
</script>

<div class="image-state-placeholder">
	<CircleAvatar {icon} size={avatarSize} disabled />
	{#if heading}
		<Text styleType="body" class="mt-m text-center">{heading}</Text>
	{/if}
	{#if message}
		<Text styleType="body-small" class="text-color-muted mt-xs text-center">{message}</Text>
	{/if}
	{#if ctaTitle}
		<ButtonV2 variant="secondary" size="s" class="mt-s" on:click={() => dispatch('cta')}>
			{ctaTitle}
		</ButtonV2>
	{/if}
</div>

<style>
	.image-state-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: var(--spacing-s, 8px);
		box-sizing: border-box;
		background-color: var(--color-1);
	}
</style>
